import React, { useMemo } from 'react';
import { formatNumber } from "../../../../../util/varibles/global";
import { IDiseaseOfSite, IUnit } from "../../../../../util/varibles/interface";
import Tabs from "../../../../Basic/Tabs";
import Icon, { ICON_NAME } from "../../../../Icon";
import UnitDisease from "../../../../Operation/FishDisease/UnitDisease";
import UnitLice from "../../../../Operation/UnitLice";
import FishHealthInfo from "../../_component/FishHealthInfo";
import LineInfo from "../../_component/LineInfo";
import AvgAmountTotal from "../../_component/UnitInfo/AvgAmountTotal";
import styles from "./style.module.scss";

const UnitInfo: React.FC<{
    data?: { detail: IUnit[] } & IUnit,
    total: { [id: string]: number },
    diseases?: IDiseaseOfSite[]
}> = ({ data, total, diseases = [] }) => {
    if (!data)
        return null;

    return <>
        <AvgAmountTotal className='mb-1' data={data} />
        <LineInfo label="Lice per fish (Adult female lice, Mobile, Stationary)" icon className="mb-1 pl-1">
            <>
                <Icon icon={ICON_NAME.LICE} />
                <UnitLice lice={data.lice || (diseases[0] || {}).lice} />
            </>
        </LineInfo>
        <div className="mb-1">
            <FishHealthInfo value={data.fish_health} />
        </div>
        <LineInfo label="Unit diseases" className='mb-1' icon>
            <>
                <Icon icon={ICON_NAME.DISEASE} />
                <UnitDisease unit={data} />
            </>
        </LineInfo>
        <div className='mt-2'>
            <div className={styles['table-header']}>
                <div>Deliv. unit</div>
                <div>Amount</div>
                <div>Lice</div>
            </div>
            {data.detail.map((detail: any) =>
                <div className={styles['table-row']} key={detail.delivery_id}>
                    <div>{detail.delivery_name}</div>
                    <div>
                        <span>{formatNumber(detail.fish_amount)}</span>
                        {detail.fish_amount !== total[detail.delivery_id] &&
                            <span className='ml-1'>(of {formatNumber(total[detail.delivery_id])})</span>}
                    </div>
                    <div>
                        <UnitLice lice={detail.lice} />
                    </div>
                </div>)}
        </div>
    </>
}

interface IProps {
    data: ({ detail: IUnit[], total: number } & IUnit)[]
    total: { [id: string]: number }
    diseases?: IDiseaseOfSite[]
}

const TransportInfo: React.FC<IProps> = ({ data, total, diseases }) => {
    const tabs = useMemo(() => data.map(item => ({
        name: `${item.site_name} - ${item.unit_id}`,
        data: item
    })), [data]);

    return <Tabs opts={tabs}>
        <UnitInfo total={total} diseases={diseases} />
    </Tabs>;
};

export default TransportInfo;

